import { useContext, useEffect } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { AuthContext } from 'modules/shared/context/AuthContext';
import routes from 'routes';

export const PublicLayout = ({ children }) => {
  const router = useRouter();
  const { user } = useContext(AuthContext);

  useEffect(() => {
    // If the user is valid, then we reroute them to the admin home page
    if (user && router.asPath !== '/') {
      router.replace(routes.Home.as);
    }
  }, []);

  return (
    <Flex
      width="100%"
      minHeight="100vh"
      justifyContent="center"
      alignItems="center"
      backgroundColor="background-subtle"
    >
      <Box p={4} m={4}>
        {children}
      </Box>
    </Flex>
  );
};
